import type { EventAttributes, EventName } from 'amazon-chime-sdk-js';
import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import { useMeetingManager } from '../MeetingProvider';

type MeetingEventProviderContextType =
  | {
      name: EventName;
      attributes: EventAttributes;
    }
  | undefined;

export const MeetingEventProviderContext =
  createContext<MeetingEventProviderContextType>(undefined);

export const MeetingEventProvider: FC<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [meetingEvent, setMeetingEvent] =
    useState<MeetingEventProviderContextType>();
  const meetingManager = useMeetingManager();

  useEffect(() => {
    function meetingEventUpdateCallback(
      name: EventName,
      attributes: EventAttributes,
    ): void {
      setMeetingEvent({ name, attributes });
    }

    meetingManager.subscribeToEventDidReceive(meetingEventUpdateCallback);

    return () => {
      meetingManager.unsubscribeFromEventDidReceive(meetingEventUpdateCallback);
    };
  }, []);

  return (
    <MeetingEventProviderContext.Provider value={meetingEvent}>
      {children}
    </MeetingEventProviderContext.Provider>
  );
};

export const useMeetingEvent = (): MeetingEventProviderContextType => {
  const meetingEvent = useContext(MeetingEventProviderContext);
  return meetingEvent;
};
